/**
 * 시험 코드 목록 (백엔드 config/examDomains.ts의 EXAM_CATALOG와 같은 값).
 * 시험 유형마다 코드를 고르면 출제 영역과 배지가 정해집니다.
 */
export type ExamLevel = 'foundational' | 'associate' | 'professional' | 'specialty';

export interface ExamCatalogItem {
  code: string;
  name: string;
  level: ExamLevel;
}

export const EXAM_CATALOG: ExamCatalogItem[] = [
  { code: 'CLF-C02', name: 'AWS Certified Cloud Practitioner', level: 'foundational' },
  { code: 'AIF-C01', name: 'AWS Certified AI Practitioner', level: 'foundational' },
  { code: 'SAA-C03', name: 'AWS Certified Solutions Architect - Associate', level: 'associate' },
  { code: 'DVA-C02', name: 'AWS Certified Developer - Associate', level: 'associate' },
  { code: 'SAP-C02', name: 'AWS Certified Solutions Architect - Professional', level: 'professional' },
  { code: 'AIP-C01', name: 'AWS Certified Generative AI Developer - Professional', level: 'professional' },
];

export const LEVEL_LABELS: Record<ExamLevel, string> = {
  foundational: 'Foundational',
  associate: 'Associate',
  professional: 'Professional',
  specialty: 'Specialty',
};

/** 배지 안에 들어가는 짧은 등급 표기 */
export const LEVEL_SHORT_LABELS: Record<ExamLevel, string> = {
  foundational: 'FOUND',
  associate: 'ASSOC',
  professional: 'PRO',
  specialty: 'SPEC',
};

export const findExamCatalogItem = (code?: string | null) =>
  code ? EXAM_CATALOG.find((item) => item.code === code.trim().toUpperCase()) : undefined;

/** 시험 유형의 시험 코드: 지정값(exam_code)이 없으면 서버가 ID에서 추측한 값(inferred_exam_code) */
export const examCodeOf = (examType?: { exam_code?: string | null; inferred_exam_code?: string | null } | null) =>
  findExamCatalogItem(examType?.exam_code || examType?.inferred_exam_code)?.code;
